import React, { Component } from "react";
import Slider from "react-slick";
import Loader from "../../../common/loader";
import { getTeamCategoryListing } from "./../../../../services/teamCategoryListing";

const LeftArrow = ({ className, style, onClick }) => {
  return (
    <button
      className={`left-arrow`}
      onClick={onClick}
      style={{
        ...style
      }}
    >
      <i
        style={{ fontSize: 20, color: "#A7A7A7" }}
        className="fa fa-long-arrow-left"
      />
    </button>
  );
};

const RightArrow = ({ className, style, onClick }) => {
  return (
    <button
      className={`right-arrow`}
      onClick={onClick}
      style={{
        ...style
      }}
    >
      <i
        style={{ fontSize: 20, color: "#A7A7A7" }}
        className="fa fa-long-arrow-right"
      />
    </button>
  );
};

class DevelopmentTeamTemplate extends Component {
  state = {
    isLoading: true,
    teamList: []
  };

  async componentDidMount() {
    const { data } = await getTeamCategoryListing();
    this.setState({ teamList: data, isLoading: false });
  }

  render() {
    const settings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      nextArrow: <RightArrow />,
      prevArrow: <LeftArrow />,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: true,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    };

    let data;

    if (this.state.loading) {
      data = <Loader />;
    } else {
      {
        this.state.teamList.map(team => {
          if (team.name === "Development Team") {

            data = team.employes.map(employee => (
              <div
                className="col  text-center team-wrapper "
                key={employee._id}
              >
                <img
                  className="img-fluid mb-4 employee-img"
                  src={employee.profile_image.url}
                />
                <h1 style={{ color: "var(--h1Color)" }}>{employee.name}</h1>
                <h2 className="designation" style={{ color: "var(--h2Color)" }}>
                  {employee.position}
                </h2>
                <a href={employee.linkedln_profile} target="_blank">
                  <img
                    className="img-fluid"
                    src={require("../../../../assets/icons/linkedin.png")}
                  />
                </a>
                <p className="about-team" style={{ color: "var(--pColor)" }}>
                  {employee.Introduction}
                </p>
              </div>
            ));
          } else {
            <h1>Nothing Found</h1>;
          }
        });
      }
    }

    if (this.state.loading) return <Loader />;
    return <Slider {...settings}>{data}</Slider>;
  }
}

export default DevelopmentTeamTemplate;
